import React, { useEffect, useState } from "react";
import { getKvkkService } from "../../../services/common.service";
import EminevimLoading from "./EminevimLoading";

const KvkkModal = ({ isOpen, onClose, onLoaded }) => {
  const [kvkkMetni, setKvkkMetni] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);
    setError("");
    setKvkkMetni("");

    getKvkkService().then(
      (response) => {
        if (cancelled) return;

        const text = response.data?.kvkkMetni ?? "";
        setKvkkMetni(text);
        setIsLoading(false);
        if (onLoaded) {
          onLoaded(text);
        }
      },
      () => {
        if (cancelled) return;

        setError("KVKK metni yüklenemedi. Lütfen tekrar deneyiniz.");
        setIsLoading(false);
      }
    );

    return () => {
      cancelled = true;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal fade show t-kvkkModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="kvkkModalTitle"
        aria-modal="true"
        style={{ display: "block", zIndex: 1055 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
          <div className="modal-content t-guarantorModal-content border-0">
            <div className="t-guarantorModal-header">
              <div className="t-guarantorModal-header-content">
                <div className="t-guarantorModal-icon">
                  <i className="t-icon-info_outline" aria-hidden="true" />
                </div>
                <div>
                  <h5 className="t-guarantorModal-title" id="kvkkModalTitle">
                    Kişisel Verilerin Korunması Kanunu Hakkında Bilgilendirme
                  </h5>
                  <p className="t-guarantorModal-subtitle">KVKK Taahhütnamesi</p>
                </div>
              </div>
              <button
                type="button"
                className="t-guarantorModal-close"
                onClick={onClose}
                aria-label="Kapat"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="t-guarantorModal-body t-kvkkModal-body">
              {isLoading ? (
                <div className="t-kvkkModal-loading">
                  <EminevimLoading subtext="KVKK metni yükleniyor, lütfen bekleyiniz." compact />
                </div>
              ) : error ? (
                <p className="t-kvkkModal-error">{error}</p>
              ) : (
                <div
                  className="t-kvkkModal-content"
                  dangerouslySetInnerHTML={{ __html: kvkkMetni }}
                />
              )}
            </div>

            <div className="t-guarantorModal-footer">
              <button
                type="button"
                className="t-memberInfo-btn t-memberInfo-btn--primary"
                onClick={onClose}
              >
                <span>Kapat</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
    </>
  );
};

export default KvkkModal;
